import React from "react";
import { Flex, Button } from "shipnow-mercurio";
const MobilePaginateButtons = ({ paginate, handleClick }) => {
  return (
    <Flex
      justifyContent={paginate.page > 1 ? "space-between" : "flex-end"}
      margin="t-20 b-4"
      width={paginate.page > 1 ? "100%" : "50%"}
      style={{
        gap: "16px",
        marginLeft: paginate.page === 1 && "50%",
      }}
    >
      {paginate.page > 1 && (
        <Button
          type="outlined"
          onClick={handleClick}
          value={paginate.page - 1}
          fullwidth
        >
          Anterior
        </Button>
      )}

      {paginate.pages > paginate.page && (
        <Button
          type="outlined"
          onClick={handleClick}
          value={paginate.page + 1}
          fullwidth
        >
          Siguiente
        </Button>
      )}
    </Flex>
  );
};

export default MobilePaginateButtons;
